// React Required
import React, { Component } from "react";
// import ReactDOM from 'react-dom';
import ReactDOM from "react-dom/client";

// Create Import File
import "./index.scss";

import PageScrollTop from "./component/PageScrollTop";

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar las traducciones
import en from './langu_text/en/translation.json';
import es from './langu_text/es/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    lng: 'es', // Idioma por defecto
    fallbackLng: 'es', // Idioma si la traducción no está disponible
    interpolation: { escapeValue: false }
  });

// Home layout
import CreativePortfolio from "./home/CreativePortfolio";

// Element Layout
import Product_1 from "./elements/Product_1";
import Product_2 from "./elements/Product_2";
import Product_3 from "./elements/Product_3";
import Product_4 from "./elements/Product_4";
import Product_5 from "./elements/Product_5";
import Product_6 from "./elements/Product_6";
import ServiceDetails from "./elements/ServiceDetails";
import About from "./elements/About";
import Contact from "./elements/Contact";
import error404 from "./elements/error404";

// Blocks Layout
import { BrowserRouter, Switch, Route } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import Process from "./elements/Process";
import Canteras from "./elements/Canteras";

class Root extends Component {
  render() {
    return (
      <BrowserRouter basename={"/"}>
        <PageScrollTop>
          <Switch>
            <Route exact path={`${process.env.PUBLIC_URL}/`} component={CreativePortfolio} />

            {/* Element Layot */}
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/product-outside`}
              component={Product_1}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/product-inside`}
              component={Product_2}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/product-facades`}
              component={Product_3}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/product-pools`}
              component={Product_4}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/product-custom`}
              component={Product_5}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/product-colors-finishes`}
              component={Product_6}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/slate-v-phyllite`}
              component={ServiceDetails}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/contact`}
              component={Contact}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/about`}
              component={About}
            />

            {/* Blocks Elements  */}
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/Process`}
              component={Process}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/the-quarries`}
              component={Canteras}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/404`}
              component={error404}
            />
            <Route component={error404} />
          </Switch>
        </PageScrollTop>
      </BrowserRouter>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
serviceWorker.register();
